(function (angular, app) {
   "use strict";
   
   // AccessControl
   angular.module(app.modules.member.name)
      .factory(app.modules.member.services.accesscontrol, AccessControlFactory);
      
   // Inject
   AccessControlFactory.$inject = [
   app.modules.common.constants.rolecheckenum
      , app.modules.common.constants.accesscontrolenum
   ];
   
   //
   function AccessControlFactory(roleCheckTypeConst, accessControlTypeConst) {
      
      //##//--------------------------------------- 
      
      // Check for Member.Auth.roles matching required roles.  CheckType = Match 1 (0) or all (1)
      var authorize = function (requiredRoles, roleCheckType) {
      
         var loginRequired = false;
         if (requiredRoles){
            loginRequired = true;
            
            // This is special role for not logged in pages. ie: Registration
            if (requiredRoles.length > 0) {
               for (var r = 0; r < requiredRoles.length; r++) {
                  if (requiredRoles[r].toUpperCase() == "ANONYMOUS") {
                     loginRequired = false;
                  }
               }
            }
         }
         
         // Delfault Result = Authorized
         var result = accessControlTypeConst.authorized, // 0
         roles = [],
         hasRole = true,
         role, i;
   
         roleCheckType = roleCheckType || roleCheckTypeConst.atLeastOne;
         
         if (loginRequired === true && !app.Member.Auth.isAuthenticated) {
            // Login Required
            result = accessControlTypeConst.loginRequired; // 1
         } else if ((loginRequired === true && app.Member.Auth.isAuthenticated) && (requiredRoles === undefined || requiredRoles.length === 0)) {
              // Login is required but no specific permissions are specified.
              result = accessControlTypeConst.authorized; // 0
         } else if (requiredRoles) {
              
              // Push member roles into array
              angular.forEach(app.Member.Auth.roles, function (role) {
                  roles.push(role.Name.toLowerCase());
              });
             

             
              
              for (i = 0; i < requiredRoles.length; i += 1) {
                  role = requiredRoles[i].toLowerCase();
                  if (roleCheckType === roleCheckTypeConst.combinationRequired) {
                      hasRole = hasRole && roles.indexOf(role) > -1;
                       // if all the permissions are required and hasPermission is false there is no point carrying on
                      if (hasRole === false) {
                          break;
                      }
                  } else if (roleCheckType === roleCheckTypeConst.atLeastOne) {
                      hasRole = roles.indexOf(role) > -1;
                      // if we only need one of the permissions and we have it there is no point carrying on
                      if (hasRole) {
                          break;
                      }
                  }
               }
              
              result = hasRole ? accessControlTypeConst.authorized : accessControlTypeConst.notAuthorized;
         }
      
         return result;
      };
      
      //##//--------------------------------------- 
      
      var service = {
         authorize: authorize
      };
      
      return service;
   }
}(angular, app));